import { render, staticRenderFns } from "./offenbarung.vue?vue&type=template&id=3153ee3c&"
import script from "./offenbarung.vue?vue&type=script&lang=js&"
export * from "./offenbarung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports